const LAYERS = [
  { name: "grey-left", ox: 17.7, oy: 56.0 },
  { name: "orange-left", ox: 17.3, oy: 34.5 },
  { name: "grey-top", ox: 40.9, oy: 29.7 },
  { name: "orange-top", ox: 64.5, oy: 21.8 },
  { name: "orange-centre", ox: 50.2, oy: 52.7 },
  { name: "grey-right", ox: 85.7, oy: 43.2 },
  { name: "grey-bottom", ox: 73.4, oy: 73.3 },
  { name: "icons", ox: 75.5, oy: 54.7, pop: true },
];

export function AnimatedLogo({ className = "" }) {
  return (
    <div className={`relative aspect-square ${className}`} role="img" aria-label="MoveTender — Australia map of moving arrows" data-testid="hero-logo-animated">
      {LAYERS.map((l, i) => (
        <img key={l.name} src={`/logo-layers/${l.name}.webp`} alt="" aria-hidden="true" draggable="false"
          className={`absolute inset-0 w-full h-full ${l.pop ? "animate-logo-pop" : "animate-logo-arrow"}`}
          style={{ transformOrigin: `${l.ox}% ${l.oy}%`, animationDelay: `${0.2 + i * 0.16}s` }}
          data-testid={`logo-layer-${l.name}`} />
      ))}
    </div>
  );
}
